export const API_SERVER = process.env.REACT_APP_SERVER_API;
export const ASSETS_URL = process.env.REACT_APP_SERVER_API;
export const ACCESS_TOKEN = '_ac_tk';
